import React from 'react'
import './Allstyles.css'


function Footer() {
  return (
    <footer className="footer py-2 text-center">
   Copy right &copy; 2022 Covid 19 Tracker - Developed by Jasir
  </footer>
  )
}

export default Footer